import React, { useEffect } from 'react';
import { cleanJson } from './utils/Columns';
import { Button } from 'react-bootstrap';

const NewDropdown = ({ type, field, handleNewType }) => {

    const url = localStorage.getItem('url');
    const dropdown = JSON.parse(localStorage.getItem('dropdown'));

    const handleAdd = () => {
        console.log('handleAdd', dropdown);
        if (dropdown.length > 0) {
            const libelle = prompt('Nouveau ' + type, '');
            if (libelle) {
                if (dropdown.filter(e => e.type === type).find(el => el.libelle.toLowerCase().trim() === libelle.toLowerCase().trim()) === undefined) {
                    newDropDown(libelle.trim());
                } else {
                    alert('Ce ' + type + ' : ' + libelle + ' existe déjà');
                }
            }
        }
    };

    const getDropdown = () => {
        console.log('getDropdown');
        return fetch(`${url}GetDropdown`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(data => {
                // console.log('Réponse du serveur:', data);
                localStorage.setItem('dropdown', JSON.stringify(cleanJson(data.data)));
            })
            .catch(error => console.error('Erreur:', error));
    }

    const newDropDown = (libelle) => {
        console.log('newDropDown', libelle);
        //ajoute a types le retour du prompt
        fetch(`${url}NewDropDown`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ type, libelle }),
        })
            .then((response) => response.json())
            .then((data) => {
                getDropdown().then(() => {
                    handleNewType(field, libelle);
                });
            })
            .catch((error) => {
                console.error('Erreur:', error);
            });

    }

    return (
        <Button variant="outline-secondary" id="button-addon2" onClick={handleAdd}>
            +
        </Button>
    );

}




export default NewDropdown;
